

const getXxx = (context, payload) => {	
    
};

export default {
  getXxx,
};